
// // src/pages/Auth/VerifyOtp.jsx
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { authAPI } from '../../api/auth.api';
// import Input from '../../components/common/Input';
// import Button from '../../components/common/Button';
// import styles from './VerifyOtp.module.css';

// const VerifyOtp = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { email, isFirstTime, message } = location.state || {};

//   const [otp, setOtp] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [otpError, setOtpError] = useState('');
//   const [passwordError, setPasswordError] = useState('');

//   useEffect(() => {
//     if (!email) {
//       navigate('/login');
//     }
//   }, [email, navigate]);

//   const validatePassword = (password) => {
//     if (password.length < 8) {
//       return 'Password must be at least 8 characters';
//     }
//     if (!/[A-Z]/.test(password)) {
//       return 'Password must contain at least one uppercase letter';
//     }
//     if (!/[a-z]/.test(password)) {
//       return 'Password must contain at least one lowercase letter';
//     }
//     if (!/[0-9]/.test(password)) {
//       return 'Password must contain at least one number';
//     }
//     if (!/[@$!%*?&#]/.test(password)) {
//       return 'Password must contain at least one special character (@$!%*?&#)';
//     }
//     return '';
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setSuccess('');
//     setOtpError('');
//     setPasswordError('');

//     // Validation
//     if (!otp.trim()) {
//       setOtpError('OTP is required');
//       return;
//     }

//     if (otp.length !== 6) {
//       setOtpError('OTP must be 6 digits');
//       return;
//     }

//     if (!newPassword.trim()) {
//       setPasswordError('Password is required');
//       return;
//     }

//     const passwordValidation = validatePassword(newPassword);
//     if (passwordValidation) {
//       setPasswordError(passwordValidation);
//       return;
//     }

//     if (newPassword !== confirmPassword) {
//       setPasswordError('Passwords do not match');
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await authAPI.verifyOtp(email, otp, newPassword);
      
//       setSuccess(response.message);
      
//       // Redirect to login after 2 seconds
//       setTimeout(() => {
//         navigate('/login', { 
//           state: { 
//             message: 'Password set successfully! Please login.' 
//           } 
//         });
//       }, 2000);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className={styles.container}>
//       <div className={styles.card}>
//         <h1 className={styles.title}>Verify OTP</h1>
//         <p className={styles.subtitle}>
//           {isFirstTime 
//             ? 'Enter the OTP sent to your email and set a new password'
//             : 'Enter the OTP sent to your email'}
//         </p>

//         <div className={styles.emailDisplay}>
//           OTP sent to: <strong>{email}</strong>
//         </div>

//         {message && (
//           <div className={`${styles.alert} ${styles.alertSuccess}`}>
//             {message}
//           </div>
//         )}
//         {error && (
//           <div className={`${styles.alert} ${styles.alertError}`}>
//             {error}
//           </div>
//         )}
//         {success && (
//           <div className={`${styles.alert} ${styles.alertSuccess}`}>
//             {success}
//           </div>
//         )}

//         <form className={styles.form} onSubmit={handleSubmit}>
//           <Input
//             type="text"
//             label="Enter OTP"
//             placeholder="Enter 6-digit OTP"
//             value={otp}
//             onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
//             error={otpError}
//             disabled={loading}
//             maxLength={6}
//             autoFocus
//           />

//           <Input
//             type="password"
//             label="New Password"
//             placeholder="Enter new password"
//             value={newPassword}
//             onChange={(e) => setNewPassword(e.target.value)}
//             error={passwordError}
//             disabled={loading}
//           />

//           <Input
//             type="password"
//             label="Confirm Password"
//             placeholder="Confirm your password"
//             value={confirmPassword}
//             onChange={(e) => setConfirmPassword(e.target.value)}
//             disabled={loading}
//           />

//           <Button type="submit" fullWidth loading={loading}>
//             Verify & Set Password
//           </Button>

//           <button 
//             type="button" 
//             className={styles.link}
//             onClick={() => navigate('/login')}
//           >
//             Back to Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default VerifyOtp;

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI } from '../../api/auth.api';
import logo from '../../assets/images/density_logo_new_trans.png';
import styles from './VerifyOtp.module.css';

const VerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, isFirstTime, message } = location.state || {};

  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [otpError, setOtpError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    if (!email) {
      navigate('/login');
    }
  }, [email, navigate]);

  const validatePassword = (password) => {
    if (password.length < 8) return 'Password must be at least 8 characters';
    if (!/[A-Z]/.test(password)) return 'Password must contain at least one uppercase letter';
    if (!/[a-z]/.test(password)) return 'Password must contain at least one lowercase letter';
    if (!/[0-9]/.test(password)) return 'Password must contain at least one number';
    if (!/[@$!%*?&#]/.test(password)) return 'Password must contain at least one special character (@$!%*?&#)';
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setOtpError('');
    setPasswordError('');

    if (!otp.trim()) { setOtpError('OTP is required'); return; }
    if (otp.length !== 6) { setOtpError('OTP must be 6 digits'); return; }
    if (!newPassword.trim()) { setPasswordError('Password is required'); return; }

    const passwordValidation = validatePassword(newPassword);
    if (passwordValidation) { setPasswordError(passwordValidation); return; }

    if (newPassword !== confirmPassword) { setPasswordError('Passwords do not match'); return; }

    setLoading(true);

    try {
      const response = await authAPI.verifyOtp(email, otp, newPassword);
      setSuccess(response.message);
      setTimeout(() => {
        navigate('/login', {
          state: { message: 'Password set successfully! Please login.' },
        });
      }, 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.root}>
      {/* LEFT PANEL */}
      <div className={styles.left}>
        <div className={styles.leftBg} />
        <div className={styles.gridOverlay} />
        <div className={`${styles.orb} ${styles.orb1}`} />
        <div className={`${styles.orb} ${styles.orb2}`} />
        <div className={`${styles.orb} ${styles.orb3}`} />
        <div className={styles.leftContent}>
          <div className={styles.divider} />
          <div className={styles.tagline}>
            Density —<br />
            <span>Happy to be</span><br />
            <em>bothered.</em>
          </div>
          <p className={styles.leftSub}>
            Your workspace for data-driven decisions — precise, fast, and beautifully simple.
          </p>
          <div className={styles.badgeRow}>
            <span className={styles.badge}>Analytics</span>
            <span className={styles.badge}>Real-time</span>
            <span className={styles.badge}>Insights</span>
          </div>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className={styles.right}>
        <div className={`${styles.rightInner} ${mounted ? styles.mounted : ''}`}>

          <div className={styles.logoWrap}>
            <img src={logo} alt="Density" className={styles.logoImg} />
          </div>

          <h1 className={styles.heading}>
            {isFirstTime ? <>Set your <em>password.</em></> : <>Verify your <em>identity.</em></>}
          </h1>
          <p className={styles.subtitle}>
            {isFirstTime
              ? 'Enter the OTP sent to your email and create a password for your account.'
              : 'Enter the OTP sent to your email to continue.'}
          </p>

          {/* Email chip */}
          <div className={styles.emailChip}>
            <span className={styles.chipDot} />
            <span className={styles.chipText}>OTP sent to: {email}</span>
          </div>

          {/* Banners */}
          {message && !success && (
            <div className={styles.successBox}>
              <svg className={styles.successIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              {message}
            </div>
          )}

          {error && (
            <div className={styles.errorBox}>
              <svg className={styles.errorIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {error}
            </div>
          )}

          {success && (
            <div className={styles.successBox}>
              <svg className={styles.successIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              {success} Redirecting…
            </div>
          )}

          <form className={styles.form} onSubmit={handleSubmit} autoComplete="off">
            <div className={styles.field}>
              <label className={styles.label}>OTP Code</label>
              <input
                className={`${styles.input} ${styles.inputOtp} ${otpError ? styles.inputError : ''}`}
                type="text"
                inputMode="numeric"
                placeholder="6-digit code"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                disabled={loading}
                maxLength={6}
                autoFocus
              />
              {otpError && <div className={styles.fieldError}>{otpError}</div>}
            </div>

            <div className={styles.field}>
              <label className={styles.label}>New Password</label>
              <input
                className={`${styles.input} ${passwordError ? styles.inputError : ''}`}
                type="password"
                placeholder="Min 8 chars, upper, number, symbol"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={loading}
              />
              {passwordError && <div className={styles.fieldError}>{passwordError}</div>}
            </div>

            <div className={styles.field}>
              <label className={styles.label}>Confirm Password</label>
              <input
                className={styles.input}
                type="password"
                placeholder="Re-enter your password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={loading}
              />
            </div>

            <button className={styles.btnPrimary} type="submit" disabled={loading || !!success}>
              <span className={styles.btnInner}>
                {loading && <span className={styles.spinner} />}
                {loading ? 'Verifying…' : 'Verify & Set Password →'}
              </span>
            </button>

            <div className={styles.linksRow}>
              <button
                type="button"
                className={styles.linkBtn}
                onClick={() => navigate('/login')}
              >
                ← Back to Login
              </button>
            </div>
          </form>

          <div className={styles.footer}>© {new Date().getFullYear()} Density. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;